import INational from "@/module/main/dto/customer/INational";

export default class National implements INational {
    constructor(
        public prefix?: string, 
        public accountNumber?: string, 
        public bankCode?: string,
    ) {}
}
